import { z } from 'zod';

/** A review belongs to one saved value; editing that value must supply its review again. */
export const ContentReview = z
  .object({
    source: z.string().trim().min(1).max(500),
    owner: z.string().trim().min(1).max(120),
    reviewed_on: z.iso.date(),
    review_due_on: z.iso.date(),
    expires_on: z.iso.date().nullable(),
  })
  .refine((r) => r.review_due_on > r.reviewed_on, {
    message: 'Next review must be after the reviewed date.',
    path: ['review_due_on'],
  })
  .refine((r) => r.expires_on === null || r.expires_on >= r.reviewed_on, {
    message: 'Expiry cannot precede review.',
    path: ['expires_on'],
  });
export type ContentReview = z.infer<typeof ContentReview>;

export const ReviewState = z.enum(['unreviewed', 'current', 'review_due', 'expired']);
export type ReviewState = z.infer<typeof ReviewState>;

export function reviewState(
  review: ContentReview | null,
  today = new Date().toISOString().slice(0, 10),
): ReviewState {
  if (!review || review.reviewed_on > today) return 'unreviewed';
  if (review.expires_on !== null && review.expires_on < today) return 'expired';
  if (review.review_due_on <= today) return 'review_due';
  return 'current';
}

export function readReview(json: string | null | undefined): ContentReview | null {
  return json ? ContentReview.parse(JSON.parse(json)) : null;
}
